import moment from 'moment';
import {CustomHeader} from "../../../../../components/AGGrid/cell-renderers/custom-header";

export const id = {
    field: 'id',
    headerName: 'ID',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'tags',
    }
};

export const name = {
    field: 'tagName',
    headerName: 'Tag Name',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'tagName',
        page: 'tags',
    }
};

export const createdBy = {
    field: 'createdBy.username',
    headerName: 'Created By',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdBy.username',
        page: 'tags',
    }
};

export const createdAt = {
    headerName: 'Created At',
    valueGetter: (data) => {
        return data?.data.createdAt && moment(data.data.createdAt).format('MM/DD/YYYY');
    },
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'tags',
    }
};
